module.exports = __webpack_public_path__ + "img/logo.b7944c1b.png";